/* ===== TRKVLT — funnel pages bypass AJAX navigation =====

   global-player.js intercepts same-origin link clicks and swaps only the
   contents of #main-content, so audio survives page changes. That works when
   both pages share the theme layout — but funnel pages use the 'funnel'
   layout, which deliberately has no site header or footer.

   Arriving at one of those via AJAX left the previous page's header and footer
   on screen, because only the main content was replaced. Loading the same URL
   directly looked correct, which made it confusing to diagnose.

   This runs in the capture phase, ahead of the AJAX handler, and stops the
   event from reaching it — without preventing the default, so the browser
   performs a normal full page load. Add any new bare-layout path to the list.
*/
(function () {
  'use strict';

  var FUNNEL_PATHS = [
    '/pages/bundle',
    '/pages/tripwire',
    '/pages/free-beats',
    '/pages/your-beats',
    '/pages/membership',
    '/pages/upgrade',
    '/pages/dynasty-offer',
    '/pages/36-beats',
    '/pages/certified',
    '/products/full-upgrade'
  ];

  function isFunnelPath(pathname) {
    var clean = (pathname || '').replace(/\/+$/, '').toLowerCase();
    for (var i = 0; i < FUNNEL_PATHS.length; i++) {
      if (clean === FUNNEL_PATHS[i]) { return true; }
    }
    return false;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
    var link = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!link || !link.href) { return; }

    var url;
    try { url = new URL(link.href, window.location.href); } catch (err) { return; }
    if (url.origin !== window.location.origin) { return; }
    if (!isFunnelPath(url.pathname)) { return; }

    /* Let the browser navigate normally; just keep the AJAX layer out of it. */
    e.stopPropagation();
  }, true);
})();
